import { useState, useEffect } from 'react';
import { StatusSection } from './StatusSection';
import { UnitInfoTable } from './UnitInfoTable';
import { getUnitProperty, isBackendUnit } from '../../schemas/unitSchema';
import { getMenderConnectionStatus } from '../../services/menderService';

export const UnitStatusColumn = ({
  selectedUnitItem,
  classifiedIssuesbyUnitAndKey,
  unitData
}) => {
  const [menderStatus, setMenderStatus] = useState('Loading...');

  const unitId = getUnitProperty(selectedUnitItem, 'unit');
  const serial = getUnitProperty(selectedUnitItem, 'display_id');

  useEffect(() => {
    if (!unitId || !serial || isBackendUnit(selectedUnitItem)) {
      setMenderStatus('-');
      return;
    }

    let cancelled = false;
    setMenderStatus('Loading...');

    getMenderConnectionStatus(unitId, serial)
      .then(({ status }) => {
        if (!cancelled) setMenderStatus(status || 'Unknown');
      })
      .catch(() => {
        if (!cancelled) setMenderStatus('Unknown');
      });

    return () => { cancelled = true; };
  }, [unitId, serial, selectedUnitItem]);

  return (
    <div className="col-4 pt-1">
      <StatusSection
        selectedUnitItem={selectedUnitItem}
        classifiedIssuesbyUnitAndKey={classifiedIssuesbyUnitAndKey}
      />

      <UnitInfoTable
        selectedUnitItem={selectedUnitItem}
        unitData={unitData}
        menderStatus={menderStatus}
      />
    </div>
  );
};